import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { AppBar, ButtonBase, Toolbar } from '@material-ui/core'
import styled, { css } from 'styled-components'
import Authentication from './Authentication'
import ContextConsumer from './Context'
import BgLogo from './BgLogo'
import theme from '../utils/theme'

const HeaderBase = styled(AppBar)`
  &.MuiAppBar-colorPrimary {
    justify-content: space-between;
    background-color: ${props => props.theme.palette.primary.main};
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  }
  & .MuiToolbar-regular {
    justify-content: space-between;
  }
`
const HeaderToolbar = styled(Toolbar)`
  @media (min-width: 768px) {
    padding-left: ${props => props.theme.spacing(6)}px;
  }
`

const HeaderTabs = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`
const HeaderTab = styled(ButtonBase)`
  min-height: 64px;
  max-width: 88px;
  padding: 0 ${props => props.theme.spacing(6)}px;
  color: inherit;
  font-size: 0.889rem;
  border: 0;
  margin: 0;
  text-transform: uppercase;
  font-weight: 600;

  ${props =>
    props.selected &&
    css`
      background-color: ${props.theme.palette.primary.main};
      color: inherit;
      border-bottom: 2px solid inherit;
    `}
`
const LogoLink = styled(Link)`
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
`

const iconDimensions = '0 0 1247.1 321.9'

const Header = props => {
  const { siteTitle, theme } = props

  const hasUserLogo = theme.imagePreviewUrl.length > 0

  return (
    <ContextConsumer>
      {({ data, set }) => (
        <HeaderBase>
          <HeaderToolbar>
            <LogoLink to="/">
              {hasUserLogo ? (
                <img
                  src={theme.imagePreviewUrl}
                  alt={`${siteTitle} logo`}
                  style={{ maxWidth: `100%`, height: `30px` }}
                />
              ) : (
                <BgLogo
                  viewBox={iconDimensions}
                  titleAccess={`${siteTitle} logo`}
                  height={32}
                ></BgLogo>
              )}
            </LogoLink>
            <HeaderTabs>
              <HeaderTab component={Link} to="/">
                Sport
              </HeaderTab>
              <HeaderTab component={Link} to="/in-play">
                InPlay
              </HeaderTab>
            </HeaderTabs>
            <Authentication data={data} set={set} />
          </HeaderToolbar>
        </HeaderBase>
      )}
    </ContextConsumer>
  )
}

export default Header

Header.propTypes = {
  siteTitle: PropTypes.string.isRequired,
  theme: PropTypes.object,
}
